import {
  Handshake,
  Eye,
  Clock,
  Lock,
  PiggyBank,
  HeartHandshake,
} from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { benefits } from "@/lib/siteConfig";

const iconMap = { Handshake, Eye, Clock, Lock, PiggyBank, HeartHandshake };

export const TrustBenefits = () => {
  return (
    <div
      className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3"
      data-testid="trust-benefits-row"
    >
      {benefits.map((b, i) => {
        const Icon = iconMap[b.icon] || Handshake;
        return (
          <Reveal key={b.title} delay={i * 0.12} className="h-full">
            <div
              className="group flex h-full items-start gap-4 rounded-2xl border border-[#D5DEE8] bg-white/85 p-6 backdrop-blur-sm transition-all duration-[350ms] ease-out hover:-translate-y-1 hover:border-[#7A1516]/25 hover:shadow-[var(--shadow-card)]"
              data-testid="trust-benefits-item"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-[#6e7683]/12 text-[#7A1516] transition-transform duration-[350ms] ease-out group-hover:-translate-y-0.5 group-hover:scale-105">
                <Icon size={22} />
              </span>
              <div className="min-w-0 flex-1">
                <h3 className="font-heading text-xl font-semibold leading-snug text-[#193D6D] [overflow-wrap:anywhere]">
                  {b.title}
                </h3>
                <p className="mt-1.5 leading-relaxed text-[#586576] hyphens-auto [overflow-wrap:anywhere]">
                  {b.text}
                </p>
              </div>
            </div>
          </Reveal>
        );
      })}
    </div>
  );
};
